import {Controller, stim} from '@oliveoilexpert/stim'
import { EventListenerSet } from '~/Helper/EventListener'

export default class HeadlineHeights extends Controller {
	static props = {
	}

	static headlineSelector = ':is(:is(.e-module-header, .e-rich-text)>:is(h2, h3, .h2, .h3))'

	static registered(identifier, stim) {
		stim.registerSelectorCallback(
			`${HeadlineHeights.headlineSelector}`,
			el => {
				const event = new CustomEvent('headline-heights:new', { detail: { element: el } })
				window.dispatchEvent(event)
			}
		)
	}
	
	listeners = new EventListenerSet()
	headlinesByPosition = {}

	matchHeadlineHeight(el) {
		el.style.removeProperty('height')
		const position = el.getBoundingClientRect().top + window.scrollY
		const height = el.getBoundingClientRect().height
		if (!this.headlinesByPosition[position]) {
			this.headlinesByPosition[position] = {
				height,
				elements: [el],
			}
			return
		}
		const positionData = this.headlinesByPosition[position]
		if (height > positionData.height) {
			positionData.height = height
			positionData.elements.forEach(existingEl => {
				existingEl.style.height = `${height}px`
			})
		}
		if (height < positionData.height) {
			el.style.height = `${positionData.height}px`
		}
		positionData.elements.push(el)
	}

	matchAllHeadlineHeights() {
		document.querySelectorAll(HeadlineHeights.headlineSelector).forEach(el => {
			this.matchHeadlineHeight(el)
		})
	}

	connected() {
		this.matchAllHeadlineHeights()
		this.listeners.add(window, 'headline-heights:new', e => {
			this.matchHeadlineHeight(e.detail.element)
		})
		let timeoutId = null
		this.resizeObserver = new ResizeObserver(entries => {
			if (timeoutId !== null) return
			timeoutId = setTimeout(() => {
				timeoutId = null
			}, 300)
			this.headlinesByPosition = {}
			this.matchAllHeadlineHeights()
		})
		this.resizeObserver.observe(document.body)
	}

	disconnected() {
		this.listeners.clear()
		this.resizeObserver.disconnect()
	}
}
